module.exports = __webpack_public_path__ + "img/ling-ling-huang.9f71c1d2.png";